import React, { useState } from "react";
import ThemSuaHangSanXuat from "./ChucNang/ThemSuaHangSanXuat";
import ThuocTinhGiamTruApi from "service/ThuocTinhGiamTruApi";
import { pushNotification } from "utils/notifications";
import XoaHangSanXuat from "./ChucNang/XoaHangSanXuat";
const HangSanXuatTable = ({ list, RoleThemMoiHangSanXuat, RoleSuaHangSanXuat, RoleXoaHangSanXuat, listCauHinhTaiSan, onSearch }) => {
    const [showModel, setShowModel] = useState(false);
    const [showModelXoa, setshowModelXoa] = useState(false);
    const [editingItem, setEditingItem] = useState(null);
    const [delId, setdelId] = useState(0);
    const btn_xoaHangSanXuatClick = (id) => {
        setdelId(id);
        setshowModelXoa(true);
    }
    const btn_SuaHangSanXuatClick = (item) => {
        setEditingItem(item);
        setShowModel(true);
    }
    const btn_themmoiHangSanXuatClick = () => {
        setEditingItem({
            ThongTinGiamTruID: 0,
            ThongTinGiamTruPID: 0,
            TenHangHoa: "",
            TenHangSanXuat: "",
            KeyThongTinGiamTru: "",
            isDel: true
        })
        setShowModel(true);
    }

    const onSaveThemSuaHangSanXuat = async (data) => {
        let success = "";
        let error = "";
        try {
            const res = await ThuocTinhGiamTruApi.addoreditHangSanXuat(data);
            const dataResponse = res.data;
            if (res.status === 200) {
                if (data.ThongTinGiamTruID !== 0) {
                    success = "Sửa thành công.";
                    setShowModel(false);
                }
                else {
                    success = "Thêm mới thành công.";
                    setShowModel(false);
                }
                pushNotification(success, "success", "TOP_CENTER", 1000);
                await onSearch();
            }
            else {
                if (data.ThongTinGiamTruID !== 0) {
                    error = "Sửa thất bại: " + dataResponse.Messages;
                }
                else {
                    error = dataResponse.Messages;
                    console.log("Error: ", error);
                }
                pushNotification(error, "error", "TOP_CENTER", 1000);
            }
        }
        catch (err) {
            console.error("Lỗi:", err);
            if (data.ThongTinGiamTruID !== 0) {
                error = "Lỗi khi gọi Api Sửa!";
            }
            else {
                error = "Lỗi khi gọi Api Thêm mới!";
            }
            pushNotification(error, "error", "TOP_CENTER", 1000);
        }
    }

    const onDelete = async (id) => {
        try {
            await ThuocTinhGiamTruApi.deleteHangSanXuat({ id });
            pushNotification("Xóa thành công!", "success", "TOP_CENTER", 1000);
            setshowModelXoa(false);
            await onSearch();
        } catch (err) {
            console.error("Lỗi khi xóa:", err);
            pushNotification("Không thể xóa. Vui lòng thử lại!", "error", "TOP_CENTER", 1000);
        }
    }

    if (!list || list.length === 0) {
        return (<>
            <div className="Left808x200 Table-main-new css-table-ds">
                <div className="card-body card-body-v2" style={{ marginBottom: "10px", maxHeight: "54px", display: RoleThemMoiHangSanXuat ? "block" : "none", }}>
                    <div className="search-new" >
                        <div className="input-sm-new" style={{ width: "12%", }}>
                            <button className="btn btn-sm" onClick={btn_themmoiHangSanXuatClick} style={{ minWidth: "100%", color: "#00B69B", border: "2px solid #00B69B", backgroundColor: "white" }}><img src="/app-assets/images/icon-them-moi-cam-do.png" class="icon-button-v2" /><span style={{ color: "" }}>Thêm mới</span></button>
                        </div>
                    </div>
                </div>
                <div className="custom-table-row">
                    <div className="custom-table-cell-v2 text-center red" style={{ width: "100%" }}>
                        Không có dữ liệu
                    </div>
                </div>
            </div>
            {
                showModel && (<ThemSuaHangSanXuat
                    onClose={() => setShowModel(false)}
                    onSave={onSaveThemSuaHangSanXuat}
                    data={editingItem}
                    listCauHinhTaiSan={listCauHinhTaiSan}
                />)
            }
        </>
        );
    }
    return (<>
        <div className="Left808x200 Table-main-new css-table-ds">
            <div className="card-body card-body-v2" style={{ marginBottom: "10px", maxHeight: "54px", display: RoleThemMoiHangSanXuat ? "block" : "none", }}>
                <div className="search-new" >
                    <div className="input-sm-new" style={{ width: "12%", }}>
                        <button className="btn btn-sm" onClick={btn_themmoiHangSanXuatClick} style={{ minWidth: "100%", color: "#00B69B", border: "2px solid #00B69B", backgroundColor: "white" }}><img src="/app-assets/images/icon-them-moi-cam-do.png" class="icon-button-v2" /><span style={{ color: "" }}>Thêm mới</span></button>
                    </div>
                </div>
            </div>
            <div className="table-mobile sticky-table-bh2 table-mobile-hover">
                <div className="custom-table-wrapper" style={{ overflowX: "auto" }}>
                    <div className="table-headers" >
                        <div className="custom-table-header flex-basis-5 flex-basis-5-sm text-center">
                            <p className="color-do-bold">
                                STT
                                <br />[{list.length === 0 ? 0 : list.length}]
                            </p>
                        </div>
                        <div className="custom-table-header flex-basis-15 flex-basis-15-sm r">
                            <p>Loại tài sản</p>
                        </div>
                        <div className="custom-table-header flex-basis-15 flex-basis-15-sm " >
                            <p>Tên hãng sản xuất</p>
                        </div>
                        <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                            <p>Chức năng</p>
                        </div>
                    </div>
                    <div className="custom-table-body">
                        <HangSanXuatTableRows
                            list={list}
                            RoleSuaHangSanXuat={RoleSuaHangSanXuat}
                            RoleXoaHangSanXuat={RoleXoaHangSanXuat}
                            btn_SuaHangSanXuatClick={btn_SuaHangSanXuatClick}
                            btn_xoaHangSanXuatClick={btn_xoaHangSanXuatClick}
                        />
                    </div>
                </div>
            </div>
        </div>
        {
            showModel && (<ThemSuaHangSanXuat
                onClose={() => setShowModel(false)}
                onSave={onSaveThemSuaHangSanXuat}
                data={editingItem}
                listCauHinhTaiSan={listCauHinhTaiSan}
            />)
        }
        {
            showModelXoa && (
                <XoaHangSanXuat
                    ThongTinGiamTruID={delId}
                    onClose={() => setshowModelXoa(false)}
                    onDelete={onDelete}
                />
            )
        }
    </>)

};


const HangSanXuatTableRows = ({ list, RoleSuaHangSanXuat, RoleXoaHangSanXuat, btn_SuaHangSanXuatClick, btn_xoaHangSanXuatClick }) => {
    return list.map((item, index) => {
        const isDel = item.isDel;
        return (
            <div className="custom-table-row" key={"item" + index} style={{ minHeight: "62px" }}>
                <div className="custom-table-cell-v2 flex-basis-5 flex-basis-5-sm disk-mobile " >
                    <span className="mobile-column-name color7-bold">STT</span>
                    <div className="center-wrapper" >
                        <p className="text-center color7">{index + 1}</p>
                    </div>
                </div>
                <div className="custom-table-cell-v2 flex-basis-15 flex-basis-15-sm " >
                    <span className="mobile-column-name color7-bold">Loại tài sản</span>
                    <div className="center-wrapper color7"
                        title={item.TenHangSanXuat}>
                        {item.TenHangHoa}
                    </div>
                </div>
                <div className="custom-table-cell-v2  flex-basis-15 flex-basis-15-sm ">
                    <span className="mobile-column-name color7-bold">Tên hãng sản xuất</span>
                    <div className="center-wrapper color7"
                        title={item.TenHangSanXuat}
                    >
                        {item.TenHangSanXuat}
                    </div>
                </div>
                <div className="custom-table-cell-v2 flex-basis-10 flex-basis-10-sm" >
                    <span className="mobile-column-name color7-bold">Chức năng</span>
                    <div className="center-wrapper" >
                        {RoleSuaHangSanXuat && (
                            <>
                                <div className="iconTableMorman">
                                    <a
                                        title="Sửa"
                                        onClick={() => btn_SuaHangSanXuatClick(item)}
                                    >
                                        <img src="/app-assets/images/icon-edit-v2.png" />
                                    </a>
                                </div>
                            </>
                        )}
                        {RoleXoaHangSanXuat && item.isDel && (
                            <>
                                <div className="iconTableMorman">
                                    <a title="Xóa"
                                        onClick={() => btn_xoaHangSanXuatClick(item.ThongTinGiamTruID)}
                                    >
                                        <img src="/app-assets/images/icon-xoa-v2.png" />
                                    </a>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        )
    });
};
export default HangSanXuatTable;